import { createAction, props, union } from '@ngrx/store';
import { Task, TaskFilter, TaskStatus } from '@/app/core/Models/Task';
import { TaskFilterDto, TasksListByChannelIdDto, TasksListDto } from '@/app/Data/DTO/TasksListDto';


export const SET_ACTIVE_TASKS_STATUS = '[TASKS] set active tasks status';
export const SetActiveTasksStatusAction = createAction(
  SET_ACTIVE_TASKS_STATUS,
  props<{ payload: TaskStatus[] }>()
);

export const GET_ALL_TASKS = '[TASKS] Get All Tasks';
export const GetAllTasksAction = createAction(
  GET_ALL_TASKS,
  props<{ payload: TasksListDto }>()
);

export const GET_ALL_TASKS_SUCCESS = '[TASKS] Get All Tasks Success';
export const GetAllTasksSuccessAction = createAction(
  GET_ALL_TASKS_SUCCESS,
  props<{ payload: Task[] }>()
);

export const GET_ALL_TASKS_FAIL = '[TASKS] Failed To Get All Tasks';
export const GetAllTasksFailAction = createAction(
  GET_ALL_TASKS_FAIL,
  props<{ payload: string }>()
);

export const GET_TASKS = '[TASKS] Get Tasks';
export const GetTasksAction = createAction(
  GET_TASKS,
  props<{ payload: TaskFilterDto }>()
);

export const GET_TASKS_SUCCESS = '[TASKS] Get Tasks Success';
export const GetTasksSuccessAction = createAction(
  GET_TASKS_SUCCESS,
  props<{ payload: Task[] }>()
);

export const GET_TASKS_FAIL = '[TASKS] Get Tasks Fail';
export const GetTasksFailAction = createAction(
  GET_TASKS_FAIL,
  props<{ payload: string }>()
);

export const GET_FILTER_TASKS = '[TASKS] Get Filter Tasks';
export const GetFilterTasksAction = createAction(
  GET_FILTER_TASKS,
  props<{ payload: any }>()
);

export const GET_FILTER_TASKS_SUCCESS = '[TASKS] Get Filter Tasks Success';
export const GetFilterTasksSuccessAction = createAction(
  GET_TASKS_SUCCESS,
  props<{ payload: Task[] }>()
);

export const GET_FILTER_TASKS_FAIL = '[TASKS] Get Filter Tasks Fail';
export const GetFilterTasksFailAction = createAction(
  GET_FILTER_TASKS_FAIL,
  props<{ payload: string }>()
);

// Home page specific actions
export const GET_MY_OPEN_TASKS_FOR_HOME = '[TASKS] Get My Open Tasks For Home';
export const GetMyOpenTasksForHomeAction = createAction(
  GET_MY_OPEN_TASKS_FOR_HOME,
  props<{ payload: { filter?: TaskFilterDto, forceRefresh?: boolean } }>()
);

export const GET_MY_OPEN_TASKS_FOR_HOME_SUCCESS = '[TASKS] Get My Open Tasks For Home Success';
export const GetMyOpenTasksForHomeSuccessAction = createAction(
  GET_MY_OPEN_TASKS_FOR_HOME_SUCCESS,
  props<{ payload: Task[] }>()
);

export const GET_MY_OPEN_TASKS_FOR_HOME_FAIL = '[TASKS] Get My Open Tasks For Home Fail';
export const GetMyOpenTasksForHomeFailAction = createAction(
  GET_MY_OPEN_TASKS_FOR_HOME_FAIL,
  props<{ payload: string }>()
);

// Cache management actions
export const INVALIDATE_TASKS_CACHE = '[TASKS] Invalidate Tasks Cache';
export const InvalidateTasksCacheAction = createAction(
  INVALIDATE_TASKS_CACHE,
  props<{ payload: { filter?: TaskFilterDto, invalidateAll?: boolean, statuses?: TaskStatus[] } }>()
);

export const INVALIDATE_TASKS_CACHE_SUCCESS = '[TASKS] Invalidate Tasks Cache Success';
export const InvalidateTasksCacheSuccessAction = createAction(
  INVALIDATE_TASKS_CACHE_SUCCESS
);

const all = union({
  SetActiveTasksStatusAction,
  GetAllTasksAction,
  GetAllTasksSuccessAction,
  GetAllTasksFailAction,
  GetTasksAction,
  GetTasksSuccessAction,
  GetTasksFailAction,
  GetFilterTasksAction,
  GetFilterTasksSuccessAction,
  GetFilterTasksFailAction,
  GetMyOpenTasksForHomeAction,
  GetMyOpenTasksForHomeSuccessAction,
  GetMyOpenTasksForHomeFailAction,
  InvalidateTasksCacheAction,
  InvalidateTasksCacheSuccessAction
})

export type TasksActions = typeof all;